/* 
  Portal Universal Search Engine 
  Filters .js-portal-search-item elements on the page in real-time.
*/

(function() {
  // Safe text highlighting function that doesn't destroy DOM event listeners
  function highlightText(element, query) {
    // 1. Clear existing highlights
    const spans = element.querySelectorAll('span.portal-highlight-wrap');
    spans.forEach(span => {
      const parent = span.parentNode;
      if (parent) {
        parent.replaceChild(document.createTextNode(span.textContent), span);
        parent.normalize();
      }
    });
    
    if (!query) return;
    
    // 2. Apply new highlights
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    
    function walk(node) {
      if (node.nodeType === 3) { // Text node
        if (node.nodeValue.trim() === '') return;
        const match = node.nodeValue.match(regex);
        if (match) {
          const span = document.createElement('span');
          span.className = 'portal-highlight-wrap';
          span.innerHTML = node.nodeValue.replace(regex, '<mark class="portal-search-highlight">$1</mark>');
          node.parentNode.replaceChild(span, node);
        }
      } else if (node.nodeType === 1) { // Element node
        const tag = node.nodeName.toUpperCase();
        // Skip script, style, SVG, and existing highlight wrappers
        if (tag !== 'SCRIPT' && tag !== 'STYLE' && tag !== 'SVG' && tag !== 'MARK' && !node.classList.contains('portal-highlight-wrap')) {
          Array.from(node.childNodes).forEach(walk);
        }
      }
    }
    walk(element);
  }

  function handleSearch(e) {
    const input = e.target;
    if (!input.classList.contains('portal-search-input')) return;

    const query = input.value.trim().toLowerCase();
    const items = document.querySelectorAll('.js-portal-search-item');
    
    if (query.length > 0) {
      document.body.classList.add('portal-is-searching');
      
      items.forEach(item => {
        const text = item.textContent.toLowerCase();
        if (text.includes(query)) {
          // It's a match!
          item.classList.remove('portal-search-hidden');
          highlightText(item, query);
          
          // Auto-open if it's an accordion
          if (item.classList.contains('portal-accordion')) {
            const trigger = item.querySelector('.portal-accordion__trigger');
            const content = item.querySelector('.portal-accordion__content');
            if (trigger) trigger.setAttribute('aria-expanded', 'true');
            if (content) content.setAttribute('data-open', 'true');
          }
          // Auto-open if it's inside a training module
          const module = item.closest('.portal-training__module');
          if (module) {
            const trigger = module.querySelector('.portal-accordion__trigger');
            const content = module.querySelector('.portal-accordion__content');
            if (trigger) trigger.setAttribute('aria-expanded', 'true');
            if (content) content.setAttribute('data-open', 'true');
          }
          
          // Auto-open any parent accordion
          const parentAccordion = item.closest('.portal-accordion');
          if (parentAccordion && !item.classList.contains('portal-accordion')) {
            parentAccordion.classList.remove('portal-search-hidden');
            const trigger = parentAccordion.querySelector('.portal-accordion__trigger');
            const content = parentAccordion.querySelector('.portal-accordion__content');
            if (trigger) trigger.setAttribute('aria-expanded', 'true');
            if (content) content.setAttribute('data-open', 'true');
          }
          
        } else {
          // No match
          item.classList.add('portal-search-hidden');
          highlightText(item, ''); // clear highlights
        }
      });
      
      // Hide empty groups (sections/categories)
      const groups = document.querySelectorAll('.portal-clinical__doc-section, .support-category');
      groups.forEach(group => {
        const itemsInGroup = group.querySelectorAll('.js-portal-search-item');
        if (itemsInGroup.length === 0) return;
        
        let hasVisible = false;
        itemsInGroup.forEach(item => {
          if (!item.classList.contains('portal-search-hidden')) {
            hasVisible = true;
          }
        });
        
        if (hasVisible) {
          group.style.display = '';
        } else {
          group.style.display = 'none';
        }
      });
      
    } else {
      // Search cleared
      document.body.classList.remove('portal-is-searching');
      items.forEach(item => {
        item.classList.remove('portal-search-hidden');
        highlightText(item, ''); // clear highlights
      });
      
      const groups = document.querySelectorAll('.portal-clinical__doc-section, .support-category');
      groups.forEach(group => {
        group.style.display = '';
      });
    }
  }

  // Use debouncing for performance if there are many items
  let searchTimeout;
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('portal-search-input')) {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => handleSearch(e), 150);
    }
  });

  // Auto-tag Wiki paragraphs and sections for unstructured search
  document.addEventListener('DOMContentLoaded', function() {
    const wikiItems = document.querySelectorAll('.portal-wiki__body > p, .portal-wiki__body > ul, .portal-wiki__body > ol, .portal-wiki__body > table, .portal-wiki__body > h2, .portal-wiki__body > h3, .portal-wiki__body > blockquote, .portal-wiki__body > div');
    wikiItems.forEach(el => el.classList.add('js-portal-search-item'));
  });

})();
